import * as React from 'react';
import { formatNumber } from '@telerik/kendo-intl';
import { InvoiceData } from '.'
import DisplayAddress from '../DisplayAddress';

type Props = {
    invoice: InvoiceData;
}

class Invoice extends React.Component<Props> {

    public render() {
        return <div className="container">
            <div className="row">
                <div className="col-sm-9">
                    <img className='invoice-logo' src={`/images/logos/${this.getTenantName()}.png`} alt='' />
                    <p>{this.props.invoice.FacilityName}<br />
                        <DisplayAddress address={this.props.invoice.FacilityAddress} />
                    </p>
                </div>
                <div className="col-sm-3 float-right" style={{ textAlign: 'center' }}>
                    <p>
                        <b>INVOICE NUMBER</b><br />
                        {this.props.invoice.Number} {(this.props.invoice.AltInvoiceNum) ? `- (Alt #: ${this.props.invoice.AltInvoiceNum})` : ''}<br />
                        <b>INVOICE PERIOD</b><br />
                        {this.props.invoice.BillingPeriodName}
                    </p>
                </div>
            </div>
            <br />
            <div>
                <p>
                    <b>Bill To</b><br />
                    {this.props.invoice.BillToName}<br />
                    <DisplayAddress address={this.props.invoice.BillToAddress} />
                </p>
            </div>
            <br />
            <br />
            <table className="table">
                <thead>
                    <tr>
                        <th>Item</th>
                        <th style={{ textAlign: 'right' }}>Qty</th>
                        <th>Description</th>
                        <th style={{ textAlign: 'right' }}>Amount</th>
                        <th style={{ textAlign: 'right' }}>Total</th>
                    </tr>
                </thead>
                <tbody>
                    {this.props.invoice.Items.map((item, index) => {
                        return <tr key={index}>
                            <td>{item.Description}</td>
                            <td style={{ textAlign: 'right' }}>{item.Quantity}</td>
                            <td>{item.UnitOfMeasure}</td>
                            <td style={{ textAlign: 'right' }}>{formatNumber(item.Rate, "c")}</td>
                            <td style={{ textAlign: 'right' }}>{formatNumber(item.Total, "c")}</td>
                        </tr>
                    })}
                    <tr>
                        <td colSpan={5} className="text-right">
                            {this.props.invoice.Tax > 0 && <React.Fragment>
                                Sub-Total {formatNumber(this.props.invoice.SubTotal, "c")}<br />
                                Tax {formatNumber(this.props.invoice.Tax, "c")}<br />
                            </React.Fragment>}
                            {this.props.invoice.DisplayOutstanding && <React.Fragment>
                                Total {formatNumber(this.props.invoice.Total, "c")}<br />
                                Outstanding Balance {formatNumber(-this.props.invoice.PreviousBalance, { style: 'accounting' })}<br />
                            </React.Fragment>}
                            <hr style={{ margin: '2px 0', padding: '0' }} />
                            <strong>Total Due {formatNumber(this.props.invoice.TotalDue, "c")}</strong>
                        </td>
                    </tr>
                </tbody>
            </table>
            {this.props.invoice.Terms && <p className="text-center">{this.props.invoice.Terms}</p>}
            <div style={{ marginBottom: '20px', pageBreakAfter: 'always' }} />
        </div>
    }

    private getTenantName(): string {
        if (typeof window !== 'undefined') {
            const hostname = window.location.hostname.split('.');
            return (hostname.length > 2) ? hostname[0].toUpperCase() : 'ANC';
        }

        return '';
    }
}

export default Invoice;
